import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, Inject, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray, FormGroupDirective, NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LGEDataService } from 'src/commons';

// export class MyErrorStateMatcher implements ErrorStateMatcher {
//     isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
//       const isSubmitted = form && form.submitted;
//       return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
//     }
//   }

@Component({
    selector: 'approve-reject-modal',
    templateUrl: '././approve-reject.component.html',
    styleUrls: ['././approve-reject.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApproveRejectModalComponent implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() message: string;
    approveRejectForm: any;

    // matcher = new MyErrorStateMatcher();

    constructor(
        private dialogRef: MatDialogRef<ApproveRejectModalComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private fb: FormBuilder,
        private _dataService: LGEDataService,
        private ref: ChangeDetectorRef,
    ) {
        this.title = data.title;
        this.message = data.message;
    }

    ngOnInit() {
        this.approveRejectForm = this.fb.group({
            comment: ['']
        });
    }

    onSubmit() {
        this.dialogRef.close(this.approveRejectForm.value);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    ngOnDestroy() {

    }

}

